import { authorizeGetRequest } from "api";
import { IPaginatedResponse } from "models";
import { IRating } from "models/rating";

export const driverRatingsApi = (
  page: number,
  perPage: number,
  search: string
) => {
  return authorizeGetRequest<IPaginatedResponse<IRating>>(
    `driver-rates?page=${page}&per_page=${perPage}&search=${search}`
  );
};

export const passengerRatingsApi = (
  page: number,
  perPage: number,
  search: string
) => {
  return authorizeGetRequest<IPaginatedResponse<IRating>>(
    `passenger-rates?page=${page}&per_page=${perPage}&search=${search}`
  );
};
